import { Button, Form, Modal } from "react-bootstrap";
import InputText from "../../common/components/InputText/InputText";
import { useState } from "react";
import useAxios from "../../common/auth/useAxios";
import { AdminCompany } from "./types/AdminTypes";
import Dropdown from "../../common/components/DropDown/DropDown";

type CreateProjectModalProps = {
  show: boolean;
  onHide: any;
  companies: AdminCompany[];
  refresh: any;
};

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({
  show,
  onHide,
  companies,
  refresh,
}) => {
  const [projectName, setProjectName] = useState<string>("");
  const [selectedCompanyId, setSelectedCompanyId] = useState<number>(0);
  const [selectedCompany, setSelectedCompany] = useState<any>();
  const { post } = useAxios();

  const companyItems = companies?.map((company, i) => {
    return { label: company.name, value: company.id, id: "" + i };
  });

  function handleSubmit(event: any) {
    event.preventDefault();
    event.stopPropagation();
    console.log(projectName);
    try {
      post("project", {
        name: projectName,
        companyId: selectedCompanyId,
      }).then((response: any) => {
        console.log(response);
        onHide();
        refresh();
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Opprett nytt prosjekt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Dropdown
            items={companyItems}
            onChange={(opt) => {
              setSelectedCompanyId(opt.value);
              setSelectedCompany(opt);
              console.log(opt.value);
            }}
            placeholder="Velg selskap"
            value={selectedCompany}
          />
          <InputText
            value={projectName}
            onChange={(e: any) => setProjectName(e.target.value)}
            inputTitle="Navne på prosjekt"
            label={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit">Lagre</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateProjectModal;
